import { createApp } from "vue";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";

import App from "./App.vue";

// Vuetify configuration
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#1976D2",
          secondary: "#424242",
          accent: "#82B1FF",
          error: "#FF5252",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FFC107",
          surface: "#FFFFFF",
          background: "#F5F5F5",
        },
      },
      dark: {
        colors: {
          primary: "#2196F3",
          secondary: "#616161",
          accent: "#FF4081",
          error: "#FF5252",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FFC107",
          surface: "#424242",
          background: "#121212",
        },
      },
    },
  },
  defaults: {
    VBtn: {
      variant: "elevated",
    },
    VCard: {
      variant: "elevated",
    },
  },
});

// Create and configure Vue app
const app = createApp(App);

// Global error handler
app.config.errorHandler = (err, vm, info) => {
  console.error("Vue Error:", err, info);

  // In production, you might want to send this to a logging service
  if (import.meta.env.PROD) {
    // Send to logging service
  }
};

// Global warning handler
app.config.warnHandler = (msg, vm, trace) => {
  if (import.meta.env.DEV) {
    console.warn("Vue Warning:", msg, trace);
  }
};

// Use Vuetify
app.use(vuetify);

// Mount application
app.mount("#app");
